<template>
  <div class="container">
    <div class="index" v-if="!detail.show">
      <div class="title">
        <span>{{$route.name}}</span>
      </div>
      <div class="query">
        <el-form ref="form" :model="form" label-width="90px"> </el-form>
        <div class="query">
          <el-form ref="form" :inline="true" :model="form" label-width="90px">
            <el-form-item label="">
              <el-select
                v-model="form.tuikuanStatus"
                placeholder="请选择学年学期"
              >
                <el-option
                  v-for="item in TKoptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="">
              <el-input
                v-model="form.stockOutNo"
                clearable
                placeholder="请输入机构名称"
              />
            </el-form-item>
            <el-form-item label="">
              <el-date-picker
                v-model="form.staterTime"
                style="width: 300px; margin-top: 4px"
                type="daterange"
                range-separator="~"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="">
              <el-button type="primary" size="small" @click="searchFun">搜索</el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="table">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            align="center"
            prop="NO"
            label="机构名称"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column align="center" prop="start_time" label="教师数">
          </el-table-column>
          <el-table-column align="center" prop="end_time" label="出勤率">
          </el-table-column>
          <el-table-column align="center" label="操作" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" @click="toDetail(scope)"
                >查看详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!--分页组件-->
      <el-pagination
        background
        :current-page="page.pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="page.pageSize"
        :total="page.totalPage"
        layout="total,prev, pager, next,jumper,sizes"
        @size-change="sizeChangeHandle"
        @current-change="currentChangeHandle"
      ></el-pagination>
    </div>
    <Detail :info="detail.info" v-if="detail.show" @to-index="toIndex"></Detail>
  </div>
</template>

<script>
// import stockOutApi from '@/api/order/stockOut';
// import StockOutForm from './StockOutForm';
// import pageMixin from '@/mixins/pageMixin';
// import searchMixin from '@/mixins/searchMixin';
// import { getToken } from '@/utils/auth';
// import store from '@/store';
export default {
  components: {
    Detail: () => import("./details.vue"),
  },
  data() {
    return {
      form: {
        tuikuanStatus: "",
        staterTime: "",
        yStatus: "",
        crateTime: "",
        stockOutNo: "", // 入库单号
        name: "", // 客户名称
        manPhone: "", // 客户电话
        storeHouseName: "", // 订单状态
        customerName: "", // 收件人名字
        customerPhone: "", // 收件人电话
        stockOutDateMin: "", // 订单开始时间
        stockOutDateMax: "", // 订单结束时间
      },
      page: {
        pageNum: 1,
        pageSize: 10,
        totalPage: 10,
      },
      info: "", // 出库单页面参数
      stockOutDate: "", // 出库时间
      downloadLoading: false, // 导出加载标志
      isShowForm: false, // 入库单添加页面标志
      tableData: [
        // {
        //   NO: "10月",
        //   start_time: "幸福童星绘",
        //   end_time: "20",
        //   orderMoney: "15",
        //   TMoney: "2",
        //   YJMoney: "0",
        //   a: "0",
        // },
        // {
        //   NO: "10月",
        //   start_time: "幸福手工绣",
        //   end_time: "20",
        //   orderMoney: "15",
        //   TMoney: "1",
        //   YJMoney: "1",
        //   a: "0",
        // },
        // {
        //   NO: "9月",
        //   start_time: "幸福童星绘",
        //   end_time: "20",
        //   orderMoney: "20",
        //   TMoney: "0",
        //   YJMoney: "0",
        //   a: "0",
        // },
        // {
        //   NO: "9月",
        //   start_time: "幸福手工绣",
        //   end_time: "20",
        //   orderMoney: "20",
        //   TMoney: "1",
        //   YJMoney: "1",
        //   a: "0",
        // },
        // {
        //   NO: "10月",
        //   start_time: "幸福童星绘",
        //   end_time: "20",
        //   orderMoney: "20",
        //   TMoney: "1",
        //   YJMoney: "2",
        //   a: "0",
        // },
        // {
        //   NO: "8月",
        //   start_time: "幸福手工绣",
        //   end_time: "20",
        //   orderMoney: "20",
        //   TMoney: "0",
        //   YJMoney: "0",
        //   a: "0",
        // },
        // {
        //   NO: "7月",
        //   start_time: "幸福童星绘",
        //   end_time: "20",
        //   orderMoney: "20",
        //   TMoney: "0",
        //   YJMoney: "0",
        //   a: "0",
        // },
        // {
        //   NO: "10月",
        //   start_time: "幸福童星绘",
        //   end_time: "20",
        //   orderMoney: "15",
        //   TMoney: "2",
        //   YJMoney: "0",
        //   a: "0",
        // },
        // {
        //   NO: "10月",
        //   start_time: "幸福童星绘",
        //   end_time: "20",
        //   orderMoney: "15",
        //   TMoney: "2",
        //   YJMoney: "0",
        //   a: "0",
        // },
        // {
        //   NO: "10月",
        //   start_time: "幸福手工绣",
        //   end_time: "20",
        //   orderMoney: "20",
        //   TMoney: "1",
        //   YJMoney: "2",
        //   a: "0",
        // },
      ],
      multipleSelection: [],
      currentPage: 4,
      TKoptions: [
        {
          value: "1",
          label: "一年级上学期",
        },
        {
          value: "2",
          label: "一年级下学期",
        },
      ],
      options: [
        {
          value: "1",
          label: "武汉东湖小学",
        },
        {
          value: "2",
          label: "芳草小学",
        },
      ],
      detail: {
        info: { name: "一年级１班" },
        show: false,
      },
    };
  },
  mounted() {
    this.getDataList();
  },
  methods: {
    getDataList() {},
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    sizeChangeHandle(val) {
      this.page.pageSize = val;

      // this.getDataList()
    },

    currentChangeHandle(val) {
      this.page.pageNum = val;
      // this.getDataList()
    },
    toDetail(scope) {
      console.log(scope);
      this.detail.show = true;
    },
    toIndex() {
      this.detail.show = false;
    },
  },
};
</script>
<style scoped>
.el-range-editor {
  width: 120%;
}
.el-range-editor >>> .el-range-separator {
  width: 8%;
}
::v-deep .el-form .el-input__inner {
  width: 150px;
  height: 32px;
  border-radius: 3px;
  background: #fff;
  border: 1px solid #ddd;
}

::v-deep .el-table__header tr th {
  background: #f7f7f7;
  box-shadow: 0px 1px 0px #eaeaea;
}

::v-deep .el-date-editor .el-range-separator {
  line-height: 22px;
}
</style>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  padding: 0 0 2% 2%;
}
.query {
  position: relative;
  margin-bottom: 2%;
}
.searchBtn {
  position: absolute;
  top: 50%;
  right: 5%;
}
.el-pagination {
  margin: 20px 0;
  padding-bottom: 30px;
  text-align: center;
}
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.el-icon-arrow-down {
  font-size: 12px;
}
.title {
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #eaeaea;
  margin-bottom: 10px;
  span {
    font-family: "PingFang SC Bold";
    font-weight: bold;
    font-size: 20px;
    text-align: left;
    color: #000;
  }
}
</style>
